function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "Group_335",
  "data-name": "Group 335",
  transform: "translate(-2025.996 -189.395)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_333",
  "data-name": "Group 333",
  transform: "translate(2030.004 193.065)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_430",
  "data-name": "Path 430",
  d: "M2092.5,253.006a2.505,2.505,0,1,1,2.505-2.505A2.508,2.508,0,0,1,2092.5,253.006Zm0-4.509a2,2,0,1,0,2,2A2.006,2.006,0,0,0,2092.5,248.5Z",
  transform: "translate(-2089.996 -247.996)",
  fill: "#fff"
})), /*#__PURE__*/React.createElement("g", {
  id: "Group_334",
  "data-name": "Group 334",
  transform: "translate(2025.996 189.395)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_431",
  "data-name": "Path 431",
  d: "M2030.245,201.746a.249.249,0,0,1-.125-.034l-1.734-1a.251.251,0,0,1-.118-.278l.408-1.633a5.1,5.1,0,0,1-.88-1.524l-1.619-.462a.251.251,0,0,1-.182-.241v-2a.251.251,0,0,1,.182-.241l1.628-.466a4.83,4.83,0,0,1,.871-1.518l-.41-1.636a.251.251,0,0,1,.118-.278l1.736-1a.251.251,0,0,1,.3.037l1.212,1.173a4.861,4.861,0,0,1,1.75,0l1.216-1.177a.251.251,0,0,1,.3-.037l1.736,1a.251.251,0,0,1,.118.278l-.409,1.632a5.124,5.124,0,0,1,.879,1.523l1.619.462a.25.25,0,0,1,.182.241v2a.251.251,0,0,1-.182.241l-1.628.465a4.827,4.827,0,0,1-.87,1.518l.41,1.636a.25.25,0,0,1-.118.278l-1.736,1a.251.251,0,0,1-.3-.037l-1.212-1.173a4.874,4.874,0,0,1-1.75,0l-1.218,1.179A.251.251,0,0,1,2030.245,201.746Zm-1.445-1.375,1.407.813,1.164-1.126a.258.258,0,0,1,.033-.03l.021-.014a.258.258,0,0,1,.185-.033,4.382,4.382,0,0,0,1.767.013.247.247,0,0,1,.26.053l1.175,1.137,1.409-.813-.4-1.586a.251.251,0,0,1,.094-.263,4.339,4.339,0,0,0,.862-1.525.25.25,0,0,1,.055-.093.245.245,0,0,1,.115-.071l1.572-.449v-1.626l-1.573-.449a.251.251,0,0,1-.181-.227,4.629,4.629,0,0,0-.84-1.454.251.251,0,0,1-.11-.247l0-.013a.255.255,0,0,1,.012-.046l.388-1.549-1.409-.814-1.175,1.137a.251.251,0,0,1-.239.062,4.368,4.368,0,0,0-1.758-.009.247.247,0,0,1-.258-.054l-1.175-1.136-1.409.813.4,1.585a.251.251,0,0,1-.092.261,4.349,4.349,0,0,0-.865,1.527.256.256,0,0,1-.17.165l-1.572.45v1.626l1.544.441.026.007.012,0a.251.251,0,0,1,.171.223,4.781,4.781,0,0,0,.353.767,4.733,4.733,0,0,0,.488.69.251.251,0,0,1,.1.27Z",
  transform: "translate(-2025.996 -189.395)",
  fill: "#fff"
})));

var SvgSettingsIcon = function SvgSettingsIcon(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13.027,
    height: 12.351,
    viewBox: "0 0 13.027 12.351",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgSettingsIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/settings_icon.39c32ee0.svg";
export { ForwardRef as ReactComponent };